module.exports = __webpack_public_path__ + "static/media/img-baner-premium-small.e3561f50.png";